import React from 'react';
import PropTypes from 'prop-types';
import { getDomain } from '@src/tools/getDomain';

export const PraSearch = ({ radioValue, user, payer, provider, payers }) => {
  const domain = getDomain('sde-claims', 3200);
  const props = {
    isClaimTab: true,
    isPraSearch: true,
  };

  return (
    <If condition={radioValue === 'prasearch'}>
      <div>
        {/* TODO */}
        <abyss-parcel
          scriptdomain={domain}
          import="claims-pra-search@dev"
          label="PRA Tab"
          showLoading
          loadingStyles={{ position: 'initial' }}
          props={JSON.stringify(props)}
          user={JSON.stringify(user)}
          payer={JSON.stringify(payer)}
          provider={JSON.stringify(provider)}
          payers={JSON.stringify(payers)}
        />
      </div>
    </If>
  );
};

PraSearch.propTypes = {
  radioValue: PropTypes.string,
};

PraSearch.defaultProps = {
  radioValue: '',
};
